// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	 $(document).ready(function () {

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
/* 
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				 */
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

				$( "[name=arrive]" ).val( selectedDate  )
				/* 
				let month = newDate.getMonth() + 1; 
				month = ( month < 10 ) ? "0" + month : month; 
				let day = ( newDate.getDate() < 10 ) ? "0" + newDate.getDate() : newDate.getDate(); 

				$( "[name=depart]" ).val( newDate.getFullYear() + "-" + month + "-" + day  );
				 */
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function(date) {
				$( "[name=depart]" ).val( date  )
			}
		});

	});



	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//scroll down click
	if(document.getElementsByClassName('scrollto').length > 0){
		document.getElementsByClassName('scrollto')[0].addEventListener('click', function(){
			animateTo('eventsform-form');
		});
	}


	//scroll down click
	if(document.getElementsByClassName('scroll-down').length > 0){
		document.getElementsByClassName('scroll-down')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}


	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	if(document.getElementById('fireclayprivateeventsform-form')) {
		let form = document.getElementById('fireclayprivateeventsform-form');
		let formButton = document.querySelector('.js-readmore');
		let formClass = formButton.querySelector('.form-module-wrapper');
		
		formButton.addEventListener('click', function(e) {
			e.preventDefault();
			form.classList.toggle('is-active');
			formButton.classList.toggle('open');
		})
	}
	if(document.getElementById('thepatiorfp-form')) {
		let form = document.getElementById('thepatiorfp-form');
		let formButton = document.querySelector('.js-readmore');
		let formClass = formButton.querySelector('.form-module-wrapper');
		
		formButton.addEventListener('click', function(e) {
			e.preventDefault();
			form.classList.toggle('is-active');
			formButton.classList.toggle('open');
		})
	}

}());


function scrollW(){
	//check scroll down or up for header styles
	 let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		 if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		 }
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


function resizeWindow(){
	//calculate a new window size
	let windowWidth = window.innerWidth||e.clientWidth||g.clientWidth;
	let windowHeight = window.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
